import { useFormFieldMutations } from "./useFormFieldMutations.js";
import { useFormInitialFields } from "./useFormInitialFields.js";
import { useFormMode } from "./useFormMode.js";
import { useFormMutation } from "./useFormMutation.js";
import { useFormName } from "./useFormName.js";
import { useFormOverrideValues } from "./useFormOverrideValues.js";
import { useFormValidations } from "./useFormValidations.js";
import { useFormVerboseMode } from "./useFormVerboseMode.js";
const emptyObject = {};
function useKeepFormUpdated(formApi, updateMode, name, fields, config = emptyObject, verbose) {
  useFormVerboseMode(formApi, updateMode, name, fields, config, verbose);
  useFormName(formApi, updateMode, name, fields, config, verbose);
  useFormInitialFields(formApi, updateMode, name, fields, config, verbose);
  useFormMode(formApi, updateMode, name, fields, config, verbose);
  useFormOverrideValues(formApi, updateMode, name, fields, config, verbose);
  useFormMutation(formApi, updateMode, name, fields, config, verbose);
  useFormFieldMutations(formApi, updateMode, name, fields, config, verbose);
  useFormValidations(formApi, updateMode, name, fields, config, verbose);
}
export {
  useKeepFormUpdated
};
//# sourceMappingURL=useKeepFormUpdated.js.map
